(() => {
  if (window.astralDirectBuyInitialized) return;

  window.astralDirectBuyInitialized = true;

  const shopRoot = window.Shopify?.routes?.root || '/';


  /* ==========================================================================
     Response helper
     ========================================================================== */

  async function readResponse(response) {
    let data = {};

    try {
      data = await response.json();
    } catch (error) {
      data = {};
    }

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          'Unable to add this product. Please try again.'
      );
    }

    return data;
  }


  /* ==========================================================================
     Button loading state
     ========================================================================== */

  function setButtonLoading(button, loading) {
    if (!button) return;

    const textElement = button.querySelector(
      '.direct-buy-button__text'
    );

    const spinner = button.querySelector(
      '.loading__spinner'
    );

    if (
      !button.dataset.originalText &&
      textElement
    ) {
      button.dataset.originalText =
        textElement.textContent?.trim() ||
        'BUY NOW';
    }

    if (loading) {
      button.disabled = true;
      button.setAttribute(
        'aria-disabled',
        'true'
      );

      button.classList.add('loading');

      if (textElement) {
        textElement.textContent =
          'OPENING CHECKOUT...';
      }

      if (spinner) {
        spinner.classList.remove('hidden');
      }

      return;
    }

    button.disabled = false;

    button.removeAttribute(
      'aria-disabled'
    );

    button.classList.remove('loading');

    if (textElement) {
      textElement.textContent =
        button.dataset.originalText ||
        'BUY NOW';
    }

    if (spinner) {
      spinner.classList.add('hidden');
    }
  }


  /* ==========================================================================
     Checkout loading reset

     Resets the button when:
     - leaving for checkout
     - returning with browser Back
     - Safari/iOS restores the page from cache
     - the tab becomes visible again
     ========================================================================== */

  function resetDirectBuyLoading() {
    document
      .querySelectorAll(
        '[data-direct-buy].loading'
      )
      .forEach((button) => {
        setButtonLoading(button, false);
      });
  }

  window.addEventListener(
    'pagehide',
    resetDirectBuyLoading
  );

  window.addEventListener(
    'pageshow',
    resetDirectBuyLoading
  );

  document.addEventListener(
    'visibilitychange',
    () => {
      if (
        document.visibilityState ===
        'visible'
      ) {
        resetDirectBuyLoading();
      }
    }
  );


  /* ==========================================================================
     Birth time display formatting
     ========================================================================== */

  function formatBirthTimeWithAmPm(
    timeValue
  ) {
    if (!timeValue) return '';

    const match = timeValue.match(
      /^([01]\d|2[0-3]):([0-5]\d)$/
    );

    if (!match) {
      return timeValue;
    }

    const hour24 = Number(match[1]);
    const minutes = match[2];

    const period =
      hour24 >= 12 ? 'PM' : 'AM';

    const hour12 =
      hour24 % 12 || 12;

    return `${hour12}:${minutes} ${period}`;
  }


  /* ==========================================================================
     Complete direct checkout
     ========================================================================== */

  async function completeDirectBuy(
    button,
    birthDetails = null
  ) {
    const productId =
      button.dataset.productId;

    const variantId =
      button.dataset.variantId;

    const sellingPlanId =
      button.dataset.sellingPlanId;

    const requiresSellingPlan =
      button.dataset.requiresSellingPlan ===
      'true';

    if (!variantId) {
      window.alert(
        'No available product variant was found.'
      );

      return;
    }

    if (
      requiresSellingPlan &&
      !sellingPlanId
    ) {
      window.alert(
        'No subscription plan was found for this product.'
      );

      return;
    }

    setButtonLoading(button, true);

    try {
      /*
       * Clear cart first so checkout only
       * contains the selected membership.
       */

      const clearResponse = await fetch(
        `${shopRoot}cart/clear.js`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      await readResponse(clearResponse);


      /*
       * Build cart item.
       */

      const cartItem = {
        id: Number(variantId),
        quantity: 1
      };

      if (sellingPlanId) {
        cartItem.selling_plan =
          Number(sellingPlanId);
      }


      /*
       * Add birth details.
       *
       * Private properties beginning with "_"
       * are retained for Shopify Flow.
       *
       * Public properties are visible on
       * the customer's order.
       */

      if (birthDetails) {
        cartItem.properties = {
          /*
           * Private copies for Shopify Flow.
           * Do not rename these.
           */

          // '_Birth date':
          //   birthDetails.birthDate,

          // '_Birth time':
          //   birthDetails.birthTimeUnknown
          //     ? 'Unknown'
          //     : birthDetails.birthTime,

          // '_Birth place':
          //   birthDetails.birthPlace,

          '_Birth time unknown':
            birthDetails.birthTimeUnknown
              ? 'Yes'
              : 'No',

          // '_Birth details source':
          //   'Membership signup',


          /*
           * Public copies shown on the order.
           */

          'Date of birth':
            birthDetails.birthDate,

          'Time of birth':
            birthDetails.birthTimeUnknown
              ? 'Unknown'
              : formatBirthTimeWithAmPm(
                  birthDetails.birthTime
                ),

          'Place of birth':
            birthDetails.birthPlace,

          'Preferred Name': '',
          'Preferred Email': ''
        };
      }


      /*
       * Add membership to cart.
       */

      const addResponse = await fetch(
        `${shopRoot}cart/add.js`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json'
          },
          body: JSON.stringify({
            items: [cartItem]
          })
        }
      );

      await readResponse(addResponse);


      /*
       * Debug information.
       */

      console.log(
        'Direct Buy product:',
        productId
      );

      console.log(
        'Direct Buy variant:',
        variantId
      );

      console.log(
        'Direct Buy selling plan:',
        sellingPlanId
      );


      /*
       * Open Shopify Checkout.
       */

      window.location.assign(
        `${shopRoot}checkout`
      );
    } catch (error) {
      console.error(
        'Direct Buy error:',
        error
      );

      window.alert(
        error.message ||
          'Unable to open checkout. Please try again.'
      );

      setButtonLoading(
        button,
        false
      );
    }
  }


  /* ==========================================================================
     Initialize birth details modal
     ========================================================================== */

    function initializeDirectBuyIOSBirthDetails(
      modal,
      form,
      nativeDate,
      nativeTime
    ) {
      /* ============================================================
        IOS / IPADOS DETECTION
        Same logic as GS V3
        ============================================================ */

      const ua = navigator.userAgent || '';

      const isIPhone =
        /iPhone|iPad|iPod/i.test(ua) ||
        (
          navigator.platform === 'MacIntel' &&
          navigator.maxTouchPoints > 1
        );

      const isIPad =
        /iPad/i.test(ua) ||
        (
          navigator.platform === 'MacIntel' &&
          navigator.maxTouchPoints > 1
        );

      if (
        !isIPhone ||
        !modal ||
        !form ||
        !nativeDate ||
        !nativeTime
      ) {
        return null;
      }


      if (
        modal.dataset.iphoneBirthDetailsInitialized ===
        'true'
      ) {
        return {
          monthInput:
            modal.querySelector(
              '[data-direct-buy-birth-month-ios]'
            )
        };
      }


      modal.dataset.iphoneBirthDetailsInitialized =
        'true';

      modal.classList.remove(
        'astral-direct-buy-is-iphone',
        'astral-direct-buy-is-ipad'
      );

      modal.classList.add(
        'astral-direct-buy-is-iphone'
      );

      if (isIPad) {
        modal.classList.add(
          'astral-direct-buy-is-ipad'
        );
      }


      /*
      * Mark the existing time field wrapper so we can
      * reproduce the GS iPad bottom alignment.
      */

      const timeField =
        nativeTime.parentElement;

      if (timeField) {
        timeField.classList.add(
          'astral-direct-buy-time-field-ios'
        );
      }


      /*
      * Mark the existing checkbox labels/inputs.
      */

      modal
        .querySelectorAll(
          'input[type="checkbox"]'
        )
        .forEach((checkbox) => {
          checkbox.classList.add(
            'astral-direct-buy-checkbox-ios'
          );

          const label =
            checkbox.closest('label');

          if (label) {
            label.classList.add(
              'astral-direct-buy-checkbox-label-ios'
            );
          }
        });


      /* ============================================================
        EXACT GS VISUAL SIZING
        DOB = 58px
        TIME = 52px
        ============================================================ */

      const STYLE_ID =
        'AstralDirectBuyIOSBirthStyles';

      if (!document.getElementById(STYLE_ID)) {
        const style =
          document.createElement('style');

        style.id = STYLE_ID;

        style.textContent = `

          /* ========================================================
            HIDE NATIVE IOS DOB FIELD
            ======================================================== */

          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-native-date-hidden {
            display: none !important;
          }


          /* ========================================================
            DOB — MM / DD / YYYY
            GS VALUES
            ======================================================== */

          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-iphone-birthdate {
            display: block;
            width: 100%;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-iphone-birthdate[hidden] {
            display: none !important;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-birthdate-parts {
            display: grid;
            grid-template-columns: 1fr 1fr 1.35fr;
            gap: 9px;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-birthdate-part {
            min-width: 0;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-birthdate-label {
            display: block;
            margin: 0 0 6px;
            font-size: 12px;
            font-weight: 700;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          [data-direct-buy-birth-month-ios],

          [data-birth-modal].astral-direct-buy-is-iphone
          [data-direct-buy-birth-day-ios],

          [data-birth-modal].astral-direct-buy-is-iphone
          [data-direct-buy-birth-year-ios] {
            width: 100% !important;
            min-width: 0;

            height: 52px;
            min-height: 52px;

            padding: 10px 8px;

            border:
              1px solid
              rgba(104, 27, 61, 0.38);

            border-radius: 10px;

            background: #fff;
            color: #211716;

            font: inherit;
            font-size: 18px;

            text-align: center;

            box-sizing: border-box;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          [data-direct-buy-birth-month-ios]:focus,

          [data-birth-modal].astral-direct-buy-is-iphone
          [data-direct-buy-birth-day-ios]:focus,

          [data-birth-modal].astral-direct-buy-is-iphone
          [data-direct-buy-birth-year-ios]:focus {
            border-color: #681b3d;

            outline:
              3px solid
              rgba(104, 27, 61, 0.12);

            outline-offset: 1px;
          }


          /*
          * GS currently hides the DOB confirmation preview.
          */

          .astral-direct-buy-birthdate-preview {
            display: none !important;
          }


          /* ========================================================
            IPHONE NATIVE TIME FIELD
            EXACT GS = 52PX, NOT 64PX
            ======================================================== */

          [data-birth-modal].astral-direct-buy-is-iphone
          [data-birth-time] {
            display: block !important;

            width: 100% !important;
            min-width: 95% !important;
            max-width: 100% !important;

            height: 52px !important;
            min-height: 52px !important;

            padding: 12px 14px !important;

            border:
              1px solid
              rgba(104, 27, 61, 0.38);

            border-radius: 10px;

            background: #fff;
            color: #211716;

            font: inherit;
            font-size: 16px !important;

            box-sizing: border-box !important;

            inline-size: 100% !important;
            min-inline-size: 95% !important;
            max-inline-size: 100% !important;

            overflow: hidden;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          [data-birth-time]::-webkit-date-and-time-value {
            width: 100%;

            margin: 0;
            padding: 0;

            text-align: left;

            position: relative;
            top: 10px !important;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          [data-birth-time]::-webkit-datetime-edit {
            padding: 0;
            margin: 0;

            position: relative;
            top: 10px !important;
          }


          /* ========================================================
            IPAD
            FORCE 52PX TIME + BOTTOM ALIGN
            ======================================================== */

          [data-birth-modal].astral-direct-buy-is-ipad
          [data-birth-time] {
            width: 100% !important;

            height: 52px !important;
            min-height: 0 !important;
            max-height: 52px !important;

            block-size: 52px !important;
            min-block-size: 0 !important;
            max-block-size: 52px !important;

            padding: 0 14px !important;

            box-sizing: border-box !important;

            -webkit-appearance: none;
            appearance: none;
          }


          [data-birth-modal].astral-direct-buy-is-ipad
          .astral-direct-buy-time-field-ios {
            align-self: end;
          }


          /* ========================================================
            IOS CHECKBOXES
            EXACT GS = 27PX
            ======================================================== */

          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-checkbox-label-ios {
            gap: 13px;
          }


          [data-birth-modal].astral-direct-buy-is-iphone
          .astral-direct-buy-checkbox-ios {
            width: 27px !important;
            height: 27px !important;

            min-width: 27px !important;

            flex-basis: 27px !important;

            margin-top: 0 !important;
          }

        `;

        document.head.appendChild(style);
      }


      /*
      * Keep Apple's native TIME picker.
      */

      nativeTime.style.removeProperty(
        'display'
      );


      /* ============================================================
        CREATE IOS DOB
        ============================================================ */

      let iphoneDateContainer =
        modal.querySelector(
          '[data-direct-buy-iphone-birthdate]'
        );


      if (!iphoneDateContainer) {
        iphoneDateContainer =
          document.createElement('div');

        iphoneDateContainer.className =
          'astral-direct-buy-iphone-birthdate';

        iphoneDateContainer.setAttribute(
          'data-direct-buy-iphone-birthdate',
          ''
        );


        iphoneDateContainer.innerHTML = `

          <div class="astral-direct-buy-birthdate-parts">

            <div class="astral-direct-buy-birthdate-part">

              <span class="astral-direct-buy-birthdate-label">
                Month
              </span>

              <input
                id="AstralDirectBuyBirthMonthIOS"
                type="text"
                inputmode="numeric"
                maxlength="2"
                placeholder="MM"
                autocomplete="off"
                aria-label="Birth month"
                required
                data-direct-buy-birth-month-ios
              >

            </div>


            <div class="astral-direct-buy-birthdate-part">

              <span class="astral-direct-buy-birthdate-label">
                Day
              </span>

              <input
                id="AstralDirectBuyBirthDayIOS"
                type="text"
                inputmode="numeric"
                maxlength="2"
                placeholder="DD"
                autocomplete="off"
                aria-label="Birth day"
                required
                data-direct-buy-birth-day-ios
              >

            </div>


            <div class="astral-direct-buy-birthdate-part">

              <span class="astral-direct-buy-birthdate-label">
                Year
              </span>

              <input
                id="AstralDirectBuyBirthYearIOS"
                type="text"
                inputmode="numeric"
                maxlength="4"
                placeholder="YYYY"
                autocomplete="off"
                aria-label="Birth year"
                required
                data-direct-buy-birth-year-ios
              >

            </div>

          </div>


          <p
            class="astral-direct-buy-birthdate-preview"
            data-direct-buy-birthdate-preview
            hidden
          ></p>
        `;


        nativeDate.insertAdjacentElement(
          'afterend',
          iphoneDateContainer
        );
      }


      iphoneDateContainer.hidden =
        false;


      const monthInput =
        iphoneDateContainer.querySelector(
          '[data-direct-buy-birth-month-ios]'
        );

      const dayInput =
        iphoneDateContainer.querySelector(
          '[data-direct-buy-birth-day-ios]'
        );

      const yearInput =
        iphoneDateContainer.querySelector(
          '[data-direct-buy-birth-year-ios]'
        );

      const preview =
        iphoneDateContainer.querySelector(
          '[data-direct-buy-birthdate-preview]'
        );


      if (
        !monthInput ||
        !dayInput ||
        !yearInput
      ) {
        return null;
      }


      /*
      * Keep the native date input as the canonical
      * YYYY-MM-DD field, exactly like GS.
      */

      nativeDate.classList.add(
        'astral-direct-buy-native-date-hidden'
      );

      nativeDate.required =
        false;

      nativeDate.setAttribute(
        'autocomplete',
        'off'
      );


      monthInput.required = true;
      dayInput.required = true;
      yearInput.required = true;


      /*
      * Date of birth label now focuses Month.
      */

      const dateLabel =
        nativeDate.labels?.[0];

      if (dateLabel) {
        dateLabel.setAttribute(
          'for',
          'AstralDirectBuyBirthMonthIOS'
        );
      }


      /* ============================================================
        HELPERS
        ============================================================ */

      function onlyDigits(
        input,
        maxLength
      ) {
        input.value =
          input.value
            .replace(/\D/g, '')
            .slice(
              0,
              maxLength
            );
      }


      function pad2(value) {
        return String(value)
          .padStart(
            2,
            '0'
          );
      }


      function clearCustomValidity() {
        monthInput.setCustomValidity('');
        dayInput.setCustomValidity('');
        yearInput.setCustomValidity('');
      }


      function clearNativeDate() {
        nativeDate.value = '';

        if (preview) {
          preview.textContent = '';
          preview.hidden = true;
        }
      }


      /* ============================================================
        VALIDATE + SAVE DOB
        Exact GS logic
        ============================================================ */

      function updateBirthDate() {
        onlyDigits(
          monthInput,
          2
        );

        onlyDigits(
          dayInput,
          2
        );

        onlyDigits(
          yearInput,
          4
        );


        clearCustomValidity();

        clearNativeDate();


        if (
          !monthInput.value ||
          !dayInput.value ||
          yearInput.value.length !== 4
        ) {
          return false;
        }


        const month =
          Number(
            monthInput.value
          );

        const day =
          Number(
            dayInput.value
          );

        const year =
          Number(
            yearInput.value
          );


        if (
          month < 1 ||
          month > 12
        ) {
          monthInput.setCustomValidity(
            'Please enter a valid month from 1 to 12.'
          );

          return false;
        }


        if (
          day < 1 ||
          day > 31
        ) {
          dayInput.setCustomValidity(
            'Please enter a valid day.'
          );

          return false;
        }


        if (
          year < 1920
        ) {
          yearInput.setCustomValidity(
            'Please enter your four-digit birth year.'
          );

          return false;
        }


        const candidateDate =
          new Date(
            year,
            month - 1,
            day
          );


        const isRealDate =
          candidateDate.getFullYear() ===
            year &&
          candidateDate.getMonth() ===
            month - 1 &&
          candidateDate.getDate() ===
            day;


        if (!isRealDate) {
          dayInput.setCustomValidity(
            'Please enter a valid date of birth.'
          );

          return false;
        }


        const now =
          new Date();

        const today =
          new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
          );


        if (
          candidateDate > today
        ) {
          yearInput.setCustomValidity(
            'Your date of birth cannot be in the future.'
          );

          return false;
        }


        const formattedValue =
          `${year}-${pad2(month)}-${pad2(day)}`;


        const previousValue =
          nativeDate.value;


        nativeDate.value =
          formattedValue;


        /*
        * GS has this preview logic,
        * but CSS intentionally hides it.
        */

        if (preview) {
          const humanDate =
            candidateDate.toLocaleDateString(
              'en-US',
              {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              }
            );

          preview.textContent =
            `✓ Birth date: ${humanDate}`;

          preview.hidden =
            false;
        }


        if (
          previousValue !==
          formattedValue
        ) {
          nativeDate.dispatchEvent(
            new Event(
              'input',
              {
                bubbles: true
              }
            )
          );

          nativeDate.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );
        }


        return true;
      }


      /* ============================================================
        RESTORE EXISTING DOB
        ============================================================ */

      function populateFromExistingDate() {
        const existing =
          nativeDate.value;


        if (
          !existing ||
          !/^\d{4}-\d{2}-\d{2}$/.test(
            existing
          )
        ) {
          return;
        }


        const parts =
          existing.split('-');


        yearInput.value =
          String(
            Number(parts[0])
          );

        monthInput.value =
          pad2(
            Number(parts[1])
          );

        dayInput.value =
          pad2(
            Number(parts[2])
          );


        updateBirthDate();
      }


      populateFromExistingDate();


      /* ============================================================
        DATE EVENTS
        ============================================================ */

      monthInput.addEventListener(
        'input',
        function () {
          onlyDigits(
            this,
            2
          );

          updateBirthDate();


          if (
            this.value.length === 2
          ) {
            dayInput.focus();
          }
        }
      );


      dayInput.addEventListener(
        'input',
        function () {
          onlyDigits(
            this,
            2
          );

          updateBirthDate();


          if (
            this.value.length === 2
          ) {
            yearInput.focus();
          }
        }
      );


      yearInput.addEventListener(
        'input',
        function () {
          onlyDigits(
            this,
            4
          );

          updateBirthDate();
        }
      );


      monthInput.addEventListener(
        'blur',
        function () {
          if (
            this.value &&
            this.value.length === 1
          ) {
            this.value =
              `0${this.value}`;
          }

          updateBirthDate();
        }
      );


      dayInput.addEventListener(
        'blur',
        function () {
          if (
            this.value &&
            this.value.length === 1
          ) {
            this.value =
              `0${this.value}`;
          }

          updateBirthDate();
        }
      );


      /* ============================================================
        FINAL SAFETY CHECK
        Capture phase, same GS behavior
        ============================================================ */

      form.addEventListener(
        'submit',
        function (event) {
          const validDate =
            updateBirthDate();


          if (!validDate) {
            event.preventDefault();

            event.stopImmediatePropagation();


            if (!monthInput.value) {
              monthInput.focus();
              monthInput.reportValidity();

              return;
            }


            if (!dayInput.value) {
              dayInput.focus();
              dayInput.reportValidity();

              return;
            }


            if (
              yearInput.value.length !== 4
            ) {
              yearInput.setCustomValidity(
                'Please enter your four-digit birth year.'
              );

              yearInput.focus();
              yearInput.reportValidity();

              return;
            }


            if (
              !monthInput.checkValidity()
            ) {
              monthInput.focus();
              monthInput.reportValidity();

              return;
            }


            if (
              !dayInput.checkValidity()
            ) {
              dayInput.focus();
              dayInput.reportValidity();

              return;
            }


            yearInput.focus();
            yearInput.reportValidity();
          }
        },
        true
      );


      return {
        monthInput,
        dayInput,
        yearInput
      };
    }

  function initializeDirectBuy() {
    const modal =
      document.querySelector(
        '[data-birth-modal]'
      );

    const form =
      modal?.querySelector(
        '[data-birth-details-form]'
      );

    const birthDateInput =
      modal?.querySelector(
        '[data-birth-date]'
      );

    const birthTimeInput =
      modal?.querySelector(
        '[data-birth-time]'
      );

    const birthPlaceInput =
      modal?.querySelector(
        '[data-birth-place]'
      );

    const unknownInput =
      modal?.querySelector(
        '[data-birth-time-unknown]'
      );

    let pendingButton = null;

    const iosBirthDetails =
      initializeDirectBuyIOSBirthDetails(
        modal,
        form,
        birthDateInput,
        birthTimeInput
      );

    /* ========================================================================
       Maximum allowed birth date
       Prevent future birth dates.
       ======================================================================== */

    function setMaximumBirthDate() {
      if (!birthDateInput) return;

      const today = new Date();

      /*
       * Convert today's local calendar date
       * into YYYY-MM-DD without UTC shifting it.
       */

      today.setMinutes(
        today.getMinutes() -
          today.getTimezoneOffset()
      );

      birthDateInput.max =
        today
          .toISOString()
          .split('T')[0];
    }


    /* ========================================================================
       Friendly future-date validation
       ======================================================================== */

    function validateBirthDate() {
      if (!birthDateInput) {
        return true;
      }

      birthDateInput.setCustomValidity(
        ''
      );

      if (
        birthDateInput.value &&
        birthDateInput.max &&
        birthDateInput.value >
          birthDateInput.max
      ) {
        birthDateInput.setCustomValidity(
          'Please enter a birth date that is not in the future.'
        );

        return false;
      }

      return true;
    }

    birthDateInput?.addEventListener(
      'change',
      validateBirthDate
    );


    /* ========================================================================
       Open modal
       ======================================================================== */

    function openBirthModal(button) {
      if (!modal || !form) {
        window.alert(
          'The birth details form could not be found.'
        );

        return;
      }

      pendingButton = button;

      setMaximumBirthDate();

      modal.hidden = false;

      document.body.classList.add(
        'birth-modal-open'
      );

      window.setTimeout(
        () => {
          if (
            iosBirthDetails?.monthInput
          ) {
            iosBirthDetails
              .monthInput
              .focus();
          } else {
            birthDateInput?.focus();
          }
        },
        50
      );
    }


    /* ========================================================================
       Close modal
       ======================================================================== */

    function closeBirthModal() {
      if (!modal) return;

      modal.hidden = true;

      document.body.classList.remove(
        'birth-modal-open'
      );

      pendingButton = null;
    }


    /* ========================================================================
       Birth time unknown checkbox
       ======================================================================== */

    function updateTimeField() {
      if (
        !birthTimeInput ||
        !unknownInput
      ) {
        return;
      }

      const isUnknown =
        unknownInput.checked;

      birthTimeInput.disabled =
        isUnknown;

      birthTimeInput.required =
        !isUnknown;

      birthTimeInput.setCustomValidity(
        ''
      );

      if (isUnknown) {
        birthTimeInput.value = '';
      }
    }


    /* ========================================================================
       Direct Buy button clicks + modal close buttons
       ======================================================================== */

    document.addEventListener(
      'click',
      (event) => {
        const directBuyButton =
          event.target.closest(
            '[data-direct-buy]'
          );

        /*
         * Handle modal close buttons.
         */

        if (!directBuyButton) {
          const closeButton =
            event.target.closest(
              '[data-birth-modal-close]'
            );

          if (closeButton) {
            event.preventDefault();

            closeBirthModal();
          }

          return;
        }

        event.preventDefault();


        /*
         * Ignore disabled buttons.
         */

        if (
          directBuyButton.disabled ||
          directBuyButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }


        /*
         * Determine whether birth details
         * are required before checkout.
         */

        const requiresBirthDetails =
          directBuyButton.dataset
            .requiresBirthDetails ===
          'true';

        if (requiresBirthDetails) {
          openBirthModal(
            directBuyButton
          );

          return;
        }


        /*
         * Products that don't require
         * birth details go directly through.
         */

        completeDirectBuy(
          directBuyButton
        );
      }
    );


    /* ========================================================================
       Unknown birth-time change
       ======================================================================== */

    unknownInput?.addEventListener(
      'change',
      updateTimeField
    );


    /* ========================================================================
       Birth details form submission
       ======================================================================== */

    form?.addEventListener(
      'submit',
      async (event) => {
        event.preventDefault();

        if (!pendingButton) {
          return;
        }

        updateTimeField();


        /*
         * Require a birth time unless
         * "I don't know" is selected.
         */

        if (
          !unknownInput?.checked &&
          !birthTimeInput?.value
        ) {
          birthTimeInput?.setCustomValidity(
            'Enter your birth time or select that it is unknown.'
          );
        }


        /*
         * Reject future birth dates with
         * a cleaner message than Safari's
         * default technical error.
         */

        validateBirthDate();


        /*
         * Allow browser to validate all
         * remaining required fields.
         */

        if (!form.reportValidity()) {
          return;
        }

        birthTimeInput?.setCustomValidity(
          ''
        );


        /*
         * Store the Buy button before
         * closing the modal.
         */

        const button =
          pendingButton;


        /*
         * Capture normalized HTML values.
         *
         * Date:
         * YYYY-MM-DD
         *
         * Time:
         * HH:mm
         */

        const birthDetails = {
          birthDate:
            birthDateInput.value,

          birthTime:
            unknownInput.checked
              ? 'Unknown'
              : birthTimeInput.value,

          birthPlace:
            birthPlaceInput.value.trim(),

          birthTimeUnknown:
            unknownInput.checked
        };


        /*
         * Close modal before opening
         * checkout.
         */

        modal.hidden = true;

        document.body.classList.remove(
          'birth-modal-open'
        );

        pendingButton = null;


        /*
         * Add membership + birth data
         * and redirect to checkout.
         */

        await completeDirectBuy(
          button,
          birthDetails
        );
      }
    );


    /* ========================================================================
       Escape key closes modal
       ======================================================================== */

    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape' &&
          modal &&
          !modal.hidden
        ) {
          closeBirthModal();
        }
      }
    );


    /* ========================================================================
       Initial state
       ======================================================================== */

    updateTimeField();

    setMaximumBirthDate();

    resetDirectBuyLoading();
  }


  /* ==========================================================================
     Initialize
     ========================================================================== */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDirectBuy,
      {
        once: true
      }
    );
  } else {
    initializeDirectBuy();
  }
})();

